import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './Instrucoes.css'; 
import manualIcon from '../../assets/manual.png';

const InstrucoesCafe = () => {
  const navigate = useNavigate();

  return (
    <div className="instrucoes-cafe-container">
      <div className="instrucoes-cafe-card">
        
        <button onClick={() => navigate(-1)} className="instrucoes-cafe-back-button">
          <FaArrowLeft /> Voltar
        </button>
        
        <div className="instrucoes-cafe-icon-container">
          <img src={manualIcon} alt="Ícone de Instruções" className="instrucoes-cafe-icon" />
        </div>
        
        <h1 className="instrucoes-cafe-title">Instruções de Uso - CalcCafé</h1>

        <div className="instrucoes-cafe-content">
          <p>
            O aplicativo pode ser usado para o cálculo de custos por safra, ou qualquer outro período desejado. Recomenda-se o uso por ciclo de produção para um controle financeiro mais preciso. Todos os gastos são expressos em Reais (R$).
          </p>
          <p>
            A ferramenta também é ideal para realizar simulações. Altere valores de insumos, produtividade esperada ou preço da saca, calcule os novos resultados e salve um PDF para comparar cenários e tomar as melhores decisões para sua lavoura.
          </p>
          
          <h2>Estrutura do Aplicativo</h2>
          <p>
            O aplicativo está estruturado em 5 telas principais de cálculo:
          </p>
          
          <div className="instrucoes-cafe-step">
            <h3>1. Produção e Produtividade</h3>
            <p>
              A primeira tela é para registrar os dados de produção da sua lavoura de café (área, número de pés, sacas colhidas) para calcular os indicadores de produtividade. Sempre que um cálculo for feito, você pode gerar um PDF com os resultados.
            </p>
          </div>

          <div className="instrucoes-cafe-step">
            <h3>2. Custo de Capital e Depreciação</h3>
            <p>
              Na segunda tela, informe os valores do capital investido na sua propriedade (benfeitorias, maquinário, valor da terra, etc.) e as taxas de remuneração e depreciação. Isso calculará o custo de oportunidade do seu capital.
            </p>
          </div>

          <div className="instrucoes-cafe-step">
            <h3>3. Custo Operacional e Total</h3>
            <p>
              A terceira tela é para o registro de todos os gastos operacionais da produção de café: fertilizantes, defensivos, mão de obra, combustível, despesas financeiras e outros custos. O cálculo fornecerá o custo operacional total e por saca.
            </p>
          </div>

          <div className="instrucoes-cafe-step">
            <h3>4. Receita e Rentabilidade</h3>
            <p>
              A quarta tela registra o total de sacas de café vendidas, o preço médio por saca e outras receitas da propriedade. Ao calcular, o sistema gera a receita total, o lucro bruto, o lucro líquido e indicadores essenciais como o ponto de equilíbrio.
            </p>
          </div>

          <div className="instrucoes-cafe-step">
            <h3>5. Relatório Final</h3>
            <p>
              A quinta tela consolida todos os dados e resultados das etapas anteriores em um relatório completo, oferecendo uma visão integrada da saúde financeira da sua produção de café.
            </p>
          </div>
          
          <p className="instrucoes-cafe-footer-text">
            Para mais informações, <Link to="/contatos">entre em contato conosco</Link>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InstrucoesCafe;
